import { FormAddonQuantities } from '@/features/pos/components/ProductConfigurationModal/form/types'

export const calcAddonsTotalQuantity = (addonQuantities: FormAddonQuantities): number => {
    let totalQuantity = 0

    for (const id in addonQuantities) {
        totalQuantity += addonQuantities[id]
    }

    return totalQuantity
}
